import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { GotoParms } from '@app/core/services/state.service';

@Injectable({ providedIn: 'root' })
export class DataMiningService {
    constructor(private datatask: DataTaskService) {}

    public async get(params: DataMiningParams): Promise<DataMiningGet | undefined> {
        return (await this.datatask.Post(812, params))[0];
    }

    public listGroupings(params: DataMiningParams): Promise<DataMiningColumn[]> {
        return this.datatask.Post(813, params);
    }

    public listNumbers(params: DataMiningParams): Promise<DataMiningColumn[]> {
        return this.datatask.Post(814, params);
    }

    public listMiningData(page: DataMiningGet): Promise<DataMiningItem[]> {
        return this.datatask.Post(815, page);
    }

    public async addNextLevel(page: DataMiningGet): Promise<DataMiningNextLevel | undefined> {
        return (await this.datatask.Post(816, page))[0];
    }
}

export interface DataMiningParams {
    p2_statsource_keyno: string | number;
    level_no: string | number;
}

export interface DataMiningGet extends DataMiningParams {
    statsource_name: string;
    filterinfo: string;
    grouping_colname: string;
    number_colname1: string;
    number_colname2: string;
    number_colname3: string;
    chart_type: string;
    item_name?: string;
}

export interface DataMiningColumn {
    grouping_colname: string;
    grouping_colname_translated?: string;
    number_colname_translated?: string;
}

export interface DataMiningItem {
    item_id: string;
    item_name: string;
    item_state?: string;
    item_parms?: GotoParms<unknown>;
    gotolink?: string;
    orderby?: string | number;
    item_secondary: DataMiningValue[];
}

export interface DataMiningValue {
    item_col: string | number;
    visible_chart?: boolean | string;
}

export interface DataMiningNextLevel {
    webpagename: string;
    parms: GotoParms<unknown>;
}
